// WS2 — Step 4 email preview. A faithful visual approximation of the
// branded set-password email the recipient will receive (the real
// rendering is server-side BrandedEmailRenderer). The CTA is visually
// a button but inert — preview only.

export interface SignupEmailPreviewProps {
  fullName: string;
  senderName: string;
  partyType: string;
  bundleNames: string[];
}

export function SignupEmailPreview({
  fullName,
  senderName,
  partyType,
  bundleNames,
}: SignupEmailPreviewProps) {
  const recipientName = fullName.trim() || "there";
  const senderDisplay = senderName.trim() || "your Phoenix Capital contact";
  const partyTypeLabel = partyType.trim().toLowerCase() || "portal user";

  return (
    <div
      className="max-w-[520px] mx-auto bg-white-pure border border-border-light rounded-lg shadow-md overflow-hidden"
      data-testid="signup-email-preview"
    >
      <div className="px-space-4 py-space-3 border-b border-border-light bg-white-warm">
        <p className="font-display font-bold text-small uppercase tracking-wider text-gold-shadow m-0">
          Phoenix Capital
        </p>
      </div>
      <div className="flex flex-col gap-space-3 px-space-4 py-space-4">
        <h2 className="font-display font-extrabold text-h3 uppercase tracking-wider text-onyx m-0">
          Welcome to Phoenix Capital
        </h2>
        <p className="text-small text-onyx m-0">
          Hi {recipientName}, {senderDisplay} has invited you to set up portal
          access as a {partyTypeLabel}. Your portal lets you submit and review
          the materials we need from you.
        </p>
        {bundleNames.length > 0 && (
          <div className="flex flex-col gap-space-1">
            <p className="text-small text-onyx m-0">You'll start with:</p>
            <ul className="list-disc pl-space-4 m-0 text-small text-onyx">
              {bundleNames.map((name) => (
                <li key={name}>{name}</li>
              ))}
            </ul>
          </div>
        )}
        <div className="flex justify-center py-space-2">
          <span
            className="inline-flex items-center justify-center bg-gold text-onyx font-display font-semibold text-label uppercase tracking-button px-space-5 py-space-2 rounded-md"
            aria-hidden="true"
          >
            Open my portal →
          </span>
        </div>
        <p className="text-small text-gray-mid m-0">
          — {senderDisplay}, Phoenix Capital
        </p>
      </div>
    </div>
  );
}
